(function () {
  'use strict';

  angular.module('app').component('tourPickupCostDetail', tourPickupCostDetail());

  function tourPickupCostDetail() {
    return {
      bindings: {
        tourPickupCosts: '=',
        tour: '=',
        paxRanges: '=',
        seasonSelected: '=',
        priceListSelected: '=',
        provider: '=',
        zones: '=',
        onTourPickupCostsSaved: '&',
        onTourPickupCostsCanceled: '&',
      },
      controller: TourPickupCostDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/tour-costs/tour-pickup-cost-detail/tour-pickup-cost-detail.component.html',
    };
  }

  TourPickupCostDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TourCostService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function TourPickupCostDetailComponent(config, UtilService, TourCostService, paxRangeService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.saveTourPickupCosts = saveTourPickupCosts;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          //selectPaxRange(item);
          setZonesData();
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          //selectPaxRange(paxRangeToSelect);
          setZonesData();
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.tourPickupCosts.length > 0) {
        // Edit and exists costs
        setSelectedPaxRanges();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.tourPickupCosts[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_PICKUP_COSTS';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_PICKUP_COSTS';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setSelectedPaxRanges() {
      vm.paxRangesSelected = [];

      vm.tourPickupCosts.forEach(function (tourPickupCost) {
        vm.paxRanges.forEach(function (paxRange) {
          if (!checkIfPaxRangeExist(paxRange) && tourPickupCost.pax_range_id === paxRange.id) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Seta all costs from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.zonesData = [];

      vm.zones.forEach(function (zone) {
        zone.pax_ranges = [];

        vm.paxRanges.forEach(function (paxRange) {
          var tourPickupCostId;
          var serviceCost = 0;

          // Exist tour pickup costs
          if (vm.tourPickupCosts.length) {
            for (var i = 0; i < vm.tourPickupCosts.length; i++) {
              var tourPickupCost = vm.tourPickupCosts[i];

              if (
                tourPickupCost.zone_id === zone.id &&
                tourPickupCost.pax_range_id === paxRange.id
              ) {
                tourPickupCostId = tourPickupCost.id;

                serviceCost = tourPickupCost.service_cost;
                break;
              }
            }
          }

          var visible = false;
          for (var j = 0; j < vm.paxRangesSelected.length; j++) {
            var paxRangeSelected = vm.paxRangesSelected[j];
            if (paxRange.id === paxRangeSelected.id) {
              visible = true;
              break;
            }
          }

          var zonePaxRange = {
            id: paxRange.id,
            service_cost: serviceCost,
            pax_from: paxRange.pax_from,
            visible: visible,
            tourPickupCostId: null,
          };

          if (tourPickupCostId) {
            zonePaxRange.tourPickupCostId = tourPickupCostId;
          }

          zone.pax_ranges.push(zonePaxRange);
        });

        vm.zonesData.push(zone);
      });
    }

    // Show/hide zone pax ranges, based on the paxRangesSelected
    function setZonesData() {
      vm.zonesData.forEach(function (zone) {
        zone.pax_ranges.forEach(function (pax_range) {
          var visible = false;
          for (var j = 0; j < vm.paxRangesSelected.length; j++) {
            var paxRangeSelected = vm.paxRangesSelected[j];
            if (pax_range.id === paxRangeSelected.id) {
              visible = true;
              break;
            }
          }

          pax_range.visible = visible;
        });
      });
    }

    function saveTourPickupCosts() {
      var tourPickupCosts = [];

      vm.zonesData.forEach(function (zone) {
        zone.pax_ranges.forEach(function (pax_range) {
          if (pax_range.visible) {
            var cost = {
              service_cost: pax_range.service_cost || 0,

              zone_id: zone.id,
              pax_range_id: pax_range.id,
              id: null,
            };

            if (pax_range.tourPickupCostId) {
              cost.id = pax_range.tourPickupCostId;
            }

            tourPickupCosts.push(cost);
          }
        });
      });

      var params = {
        tour_pickup_costs: tourPickupCosts,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
        provider_id: vm.provider.id,
      };

      // console.log(params);
      // return;

      vm.sendingForm = true;
      TourCostService.saveTourPickupCosts(vm.tour, params, vm.editMode).then(function (data) {
        vm.onTourPickupCostsSaved();

        setItemOptions(data[0].updated_at);

        vm.tourPickupCosts = data;
        setPaxRangesData();

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onTourPickupCostsCanceled();
    }
  }
})();
